import {useTranslation} from "react-i18next";
import logoLight from "../../../assets/images/Brand logo/LOGOTIPO_AYG.svg";
import logoDark from "../../../assets/images/Brand logo/LOGOTIPO_AYG_1.svg";
import {SEO} from "../../../components";
import {BaseBreadcrumb} from "../../../components/BaseBreadcrumb";
import classes from "./TermsOfService.module.css";

const TERMS_SECTIONS = Array.from({length: 14}, (_, i) => i + 1);

const POLICY_SECTIONS = [
  {key: 1, hasList: true, items: 3},
  {key: 2, hasList: true, items: 3},
  {key: 3, hasList: true, items: 2},
  {key: 4, hasList: true, items: 2},
  {key: 5, hasList: false},
  {key: 6, hasList: false},
];

const TermsOfService = () => {
  const {t} = useTranslation();

  return (
    <>
      <SEO
        title="Términos y Condiciones - Aprieta y Gana"
        description="Términos y condiciones de uso de la plataforma Aprieta y Gana."
        path="/terminos-y-condiciones"
      />

      <div className={classes.page}>
        <BaseBreadcrumb items={[{label: t("breadcrumbHome"), path: "/"}, {label: t("breadcrumbTerms")}]} />

        <header className={classes.hero}>
          <img
            src={logoDark}
            alt="Aprieta y Gana"
            className={`${classes.logo} ${classes.logoDark}`}
          />
          <img
            src={logoLight}
            alt="Aprieta y Gana"
            className={`${classes.logo} ${classes.logoLight}`}
          />
          <h1>{t("TOStitle")}</h1>
        </header>

        <div className={classes.divider} />

        <nav className={classes.toc}>
          <h2>{t("TOStocTitle") || "Contenido"}</h2>
          <ol>
            {TERMS_SECTIONS.map(n => (
              <li key={n}>
                <a href={`#section-${n}`}>{t(`TOSParagraphtitle${n === 1 ? "" : n}`)}</a>
              </li>
            ))}
          </ol>
        </nav>

        <div className={classes.content}>
          {TERMS_SECTIONS.map(n => {
            const titleKey = `TOSParagraphtitle${n === 1 ? "" : n}`;
            const bodyKey = `TOSParagraph${n === 1 ? "" : n}`;

            return (
              <section
                key={n}
                id={`section-${n}`}
                className={classes.section}
              >
                <div className={classes.sectionHeader}>
                  <span className={classes.sectionNumber}>{n}</span>
                  <h3 className={classes.sectionTitle}>{t(titleKey)}</h3>
                </div>
                <div className={classes.sectionBody}>
                  <p>{t(bodyKey)}</p>
                  {n === 4 && (
                    <>
                      <p>{t("TOSParagraph4_1")}</p>
                      <p>{t("TOSParagraph4_2")}</p>
                    </>
                  )}
                </div>
              </section>
            );
          })}

          <div className={classes.note}>
            <p className={classes.noteLabel}>{t("TOSParagraphNote")}</p>
            <p>{t("TOSParagraphNoteContent")}</p>
          </div>

          <div className={classes.divider} />

          <h2 className={classes.policiesHeading}>{t("TOSPolitics")}</h2>

          {POLICY_SECTIONS.map(({key, hasList, items}) => (
            <section
              key={key}
              className={classes.policySection}
            >
              <h3 className={classes.policyTitle}>
                {key}. {t(`TOSPolitics_${key}`)}
              </h3>
              {hasList ? (
                <ul>
                  {Array.from({length: items}, (_, i) => (
                    <li key={`policy-${key}-${i + 1}`}>{t(`TOSPolitics_${key}_${i + 1}`)}</li>
                  ))}
                </ul>
              ) : (
                <p>{t(`TOSPolitics_${key}_1`)}</p>
              )}
            </section>
          ))}

          <div className={classes.privacyBanner}>
            <p>{t("TOSPrivacyPolicy")}</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default TermsOfService;
